export function globalFunctions() {
    // white and black overlay backgrounds to hide site from peeking through when triggered
    jQuery('.wrapper').prepend('<div class="wrapper-overlay"></div><div class="wrapper-overlay-dark"></div>');

    jQuery('input:not([type=file],[type=hidden],[type=image],[type=button])').on('blur', function () {
        jQuery(this).val(jQuery(this).val().trim());
    });

    // Remove country options that aren't US
    jQuery('#country > option').each(function () {
        if (this.value != 'US') {
            jQuery(this).remove();
        }
    });

    if (jQuery('.col-left.sidebar .block-layered-nav').length) {
        var filters = jQuery('.col-left.sidebar .block-layered-nav')[0].outerHTML;
        if (filters != '' && filters != undefined) {
            jQuery('.toolbar-top .filters').html(filters);
        }
    }

    const header = document.querySelector('body');

    const headroom = new Headroom(header, {
        tolerance: 5,
        offset: 80,
        classes: {
            initial: 'headroom',
            pinned: 'headroom--pinned',
            unpinned: 'headroom--unpinned',
            top: 'headroom--top',
            notTop: 'headroom--not-top'
        }
    });

    headroom.init();
}